import type { AppointmentType, Type } from '@mend/types/appointment';
import type { Response } from '#types/common.ts';

import { api } from '#services/http-clients.ts';

/**
 * Compared to `/appointment-type/type/all` (without a type passed here), this
 * endpoint does NOT return the types where `visible = 0`.
 */
export function getAppointmentTypes(type?: Type): Promise<AppointmentType[]> {
  return api
    .get<
      Response<{ appointmentTypes: AppointmentType[] }>
    >(`/appointment-type${type ? `/${type}` : ''}`)
    .then((res) => res.data.payload.appointmentTypes);
}
